import { useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  BuyerActivityStatusSubscription,
  BuyerActivityStatusSubscriptionVariables,
  OpportunityQuery,
} from "lib/generated/app-service-gql/graphql";
import { useSubscription } from "../useGraphQlClient";

// adding this so it generates the types
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const buyerActivitySummary = graphql(`
  subscription buyerActivityStatus($opportunityId: String!) {
    buyerActivityStatus(opportunityId: $opportunityId) {
      opportunityId
      isComplete
      result {
        status
        createdAt
        questions {
          question
          answer
        }
        relatedNotices {
          guid
          name
          stage
          stagev2
          expiryDate
          closeDate
          publishDate
          value
          lots {
            suppliers {
              guid
              name
            }
          }
          buyers {
            guid
          }
          procurementStage {
            id
            stage
          }
        }
      }
    }
  }
`);

type BuyerActivityStatusProps = {
  opportunityId: string;
  enabled?: boolean;
};

export function useBuyerActivityStatus({
  opportunityId,
  enabled = true,
}: BuyerActivityStatusProps) {
  const queryClient = useQueryClient();

  return useSubscription<BuyerActivityStatusSubscription, BuyerActivityStatusSubscriptionVariables>(
    `subscription buyerActivityStatus($opportunityId: String!) {
        buyerActivityStatus(opportunityId: $opportunityId) {
            opportunityId
            isComplete
            result {
              status
              createdAt
              questions {
                question
                answer
              }
              relatedNotices {
                guid
                name
                stage
                stagev2
                expiryDate
                closeDate
                publishDate
                value
                lots {
                  suppliers {
                    guid
                    name
                  }
                }
                buyers {
                  guid
                }
                procurementStage {
                  id
                  stage
                }
              }
            }
          }
        }
    `,
    {
      opportunityId,
    },
    {
      onData: (data) => {
        if (data.buyerActivityStatus.isComplete) {
          queryClient.setQueryData<OpportunityQuery>(
            ["opportunity", data.buyerActivityStatus.opportunityId],
            (oldData) => {
              if (!oldData) {
                return undefined;
              }

              return {
                ...oldData,
                opportunity: {
                  ...oldData.opportunity,
                  buyerActivity: data.buyerActivityStatus.result,
                },
              };
            },
          );
        }
      },
      enabled,
    },
  );
}
